import mitt from "mitt";
import { onUnmounted } from "vue";

type ApplicationEvents = {
  "close-all-overlays": void;
  "open-shopping-cart": void;
};

export default defineNuxtPlugin((app) => {
  const emitter = mitt<ApplicationEvents>();

  // Function to register an event listener and automatically remove it when the component unmounts
  const lifecycleAwareListen = (
    type: keyof ApplicationEvents,
    handler: () => void
  ) => {
    emitter.on(type, handler);
    onUnmounted(() => emitter.off(type, handler));
  };

  return {
    provide: {
      emitEvent: emitter.emit, // Will emit an event
      listen: lifecycleAwareListen, // Will register a listener for an event
    },
  };
});
